<template>
  <div>callback...</div>
</template>

<script>

export default {
  name: 'Callback',

  created () {
    let x = this
    console.log('Callback from IDP')
    this.$auth.userManager.signinRedirectCallback().then(function (user) {
      x.$auth.user = user
      console.log('signin response success', user)
      window.location.href = '../'
    }).catch(function (err) {
      console.log(err)
    })

  // var mgr = new Oidc.UserManager({
  //   response_mode: 'query',
  //   userStore: new Oidc.WebStorageStateStore({store: window.localStorage})
  // }).signinRedirectCallback().then(function (user) {
  //   console.log('signin response success', user)
  //   window.location.href = '../'
  // }).catch(function (err) {
  //   console.log(err)
  // })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Callback.vue